import script from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductsTable.vue?vue&type=style&index=0&id=56a43e54&lang=scss"

const __exports__ = script;

export default __exports__